import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import {
  getListSubCategories, getPreSelectedSubCategory, customStyles, customStylesTotal, getSubLabel,
} from '../../../utils/functions';

const FormEstate = (props) => {
  const {
    data, handleInputChange, isViewOnly,
  } = props;
  const {
    title, notes, isLoading, address, category, subcategory,
  } = data;
    const listOptions = getListSubCategories(category);

    return (
      <div>
        <div className="form__form-group">
          <span className="form__form-group-label">Type de bien</span>
          <div className="form__form-group-field priority">
            <Select
              options={listOptions}
              name={category}
              // onChange={handleSelectChange}
              defaultValue={subcategory ? getPreSelectedSubCategory(category, subcategory) : {}}
              className="fullWidth"
              placeholder="Sélectionner..."
              theme={customStyles}
              styles={customStylesTotal}
              isDisabled
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">Nom du bien <span className="reddish-text">*</span></span>
          <div className="form__form-group-field priority">
            <input
              type="text"
              required
              value={title}
              name="title"
              onChange={handleInputChange}
              maxLength="200"
              disabled={isLoading || isViewOnly}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">Adresse</span>
          <div className="form__form-group-field priority">
            <input
              type="text"
              required
              value={address || ''}
              name="address"
              onChange={handleInputChange}
              maxLength="200"
              disabled={isLoading || isViewOnly}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">Informations complémentaires</span>
          <div className="form__form-group-field">
            <textarea
              placeholder={getSubLabel('assets', 'notes', data)}
              required
              style={{ height: 70, minHeight: 70 }}
              value={notes || ''}
              name="notes"
              onChange={handleInputChange}
              maxLength="2000"
              disabled={isLoading || isViewOnly}
            />
          </div>
        </div>
      </div>
    );
};

FormEstate.propTypes = {
  data: PropTypes.shape({}).isRequired,
  handleInputChange: PropTypes.func,
  isViewOnly: PropTypes.bool,
};

FormEstate.defaultProps = {
  handleInputChange: () => {},
  isViewOnly: false,
};

export default FormEstate;
